const updateCartData = (data) => {
    fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    })
        .then((response) => {
            return response.json();
        })
        .catch((error) => {
            console.error("Error:", error);
        })
        .then((response) => {
            console.log(response);
            window.location.reload();
        });
};

const checkQuantity = (quantity, max) => {
    if (Number(quantity) > Number(max)) {
        return true;
    }
    return false;
};

document.addEventListener("DOMContentLoaded", () => {
    const quantityInputs = document.querySelectorAll(".quantity__input");
    quantityInputs.forEach((input) => {
        // max 属性を取得
        const max = input.getAttribute("max");
        //   variant id を取得
        const variantId = input.getAttribute("data-quantity-variant-id");

        let quantity = input.value;

        if (max && checkQuantity(quantity, max)) {
            input.value = max;
            data = {
                quantity: max,
                id: variantId,
            };
            alert("購入制限数を超えている商品を更新します");
            updateCartData(data);
        }

        // max が設定されている場合
        if (max) {
            input.addEventListener("change", (event) => {
                let quantity = event.target.value;

                // max が設定されていて、quantity が max より大きい場合
                if (checkQuantity(quantity, max)) {
                    // quantity を max に設定
                    input.value = max;

                    data = {
                        quantity: max,
                        id: variantId,
                    };
                    updateCartData(data);
                    alert("購入制限数を超えています");
                }
            });
        }
    });
});
